
import { Component, Mixins } from "vue-property-decorator";
import { TimeFormatKinds, ITimeStyle } from "../../../../../../documaker/domain/format/objects";
import { ITimeStylePropertyEditable, instanceOfITimeStylePropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TimeStylePropertyEditableMixin extends Mixins() {
  writePropertyWhenValid: (writer: (source: ITimeStylePropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITimeStylePropertyEditable) => T, defaultValue: T) => T;

  get isTimeStylePropertyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITimeStylePropertyEditable(s) && s.timeStyle().isEditable(), false);
  }

  get timeStyle(): ITimeStyle {
    return this.readPropertyOrDefault(s => s.timeStyle().getValue(), { formatKind: TimeFormatKinds.String12hJa });
  }

  set timeStyle(value: ITimeStyle) {
    this.writePropertyWhenValid(s => s.timeStyle().setValue(value));
  }
}

